/* KILLIK — menu tabs, diet and spirit filters, coming-soon sign-up */
(() => {
  'use strict';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Menu tabs (set up per section, again after theme-editor redraws) ── */
  function initMenus(sec) {
    if (sec.dataset.ready) return;
    const tabs = [...sec.querySelectorAll('.menu-tabs [data-tab]')];
    const panels = [...sec.querySelectorAll('.menu-panel')];
    if (!tabs.length) return;
    sec.dataset.ready = '1';
    const show = (id, animate) => {
      tabs.forEach(b => b.setAttribute('aria-selected', b.dataset.tab === id));
      panels.forEach(p => {
        const on = p.dataset.panel === id;
        p.hidden = !on;
        if (on && animate && !reduced) p.animate([{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'none' }], { duration: 500, easing: 'cubic-bezier(.16,1,.3,1)' });
      });
    };
    tabs.forEach((b, i) => {
      b.addEventListener('click', () => show(b.dataset.tab, true));
      b.addEventListener('keydown', e => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const j = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        tabs[j].focus(); show(tabs[j].dataset.tab, true);
      });
    });
    show(tabs[0].dataset.tab, false);
    sec.killikShow = show;

    // diet filters (food)
    const diets = {
      gf: t => /\sGFO?\s/.test(t),
      veg: t => /\s(VEGO?|VO?)\s/.test(t),
      v: t => /\sVO?\s/.test(t),
      df: t => /\sDFO?\s/.test(t),
      nuts: t => !/\sNUTS\s/.test(t),
    };
    const picked = new Set();
    sec.querySelectorAll('[data-diet]').forEach(b => b.addEventListener('click', () => {
      const k = b.dataset.diet;
      picked.has(k) ? picked.delete(k) : picked.add(k);
      b.setAttribute('aria-pressed', picked.has(k));
      const panel = b.closest('.menu-panel');
      panel.querySelectorAll('.mi').forEach(mi => {
        const tags = mi.dataset.tags || ' ';
        mi.classList.toggle('off', [...picked].some(d => !diets[d](tags)));
      });
    }));

    // "made with" spirit filter (cocktails); hide spirits no cocktail uses
    const sfButtons = [...sec.querySelectorAll('[data-sf]')];
    if (sfButtons.length) {
      const panel = sfButtons[0].closest('.menu-panel');
      const items = [...panel.querySelectorAll('.mi')];
      sfButtons.forEach(b => {
        const h = b.dataset.sf;
        if (h && !items.some(mi => (mi.dataset.spirits || '').includes(',' + h + ','))) b.hidden = true;
        b.addEventListener('click', () => {
          sfButtons.forEach(x => x.setAttribute('aria-pressed', x === b));
          items.forEach(mi => mi.classList.toggle('off', !!h && !(mi.dataset.spirits || '').includes(',' + h + ',')));
        });
      });
    }
  }
  document.querySelectorAll('.menus').forEach(initMenus);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('.menus').forEach(initMenus));
  // selecting a menu block in the theme editor shows the tab it lives on
  document.addEventListener('shopify:block:select', e => {
    const sec = e.target.closest('.menus');
    const panel = e.target.closest('.menu-panel');
    if (sec && panel && sec.killikShow) sec.killikShow(panel.dataset.panel, false);
  });

  /* ── Coming-soon "Join the list" dialog ── */
  const dlg = document.getElementById('notify');
  if (!dlg) return;
  const tags = document.getElementById('notifyTags');
  const kicker = document.getElementById('notifyKicker');
  const lede = document.getElementById('notifyLede');
  let last = null;
  const fieldsEl = dlg.querySelector('[data-form-fields]'), okEl = dlg.querySelector('[data-form-ok]'), errEl = dlg.querySelector('[data-form-error]');
  const open = (handle, name, keepState) => {
    last = document.activeElement;
    if (!keepState) {
      if (fieldsEl) fieldsEl.hidden = false;
      if (okEl) okEl.hidden = true;
      if (errEl && !errEl.textContent.trim()) errEl.hidden = true;
    }
    if (tags) tags.value = 'newsletter' + (handle ? ',interest-' + handle : '');
    if (kicker && name) kicker.textContent = name + ' · Coming soon';
    if (lede && name) lede.textContent = 'Join the list and we’ll email you when ' + name + ' is released.';
    dlg.hidden = false; document.body.classList.add('locked');
    const input = document.getElementById('notifyEmail');
    (input || document.getElementById('notifyClose')).focus({ preventScroll: true });
  };
  const close = () => { dlg.hidden = true; document.body.classList.remove('locked'); last && last.focus({ preventScroll: true }); };
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-notify]');
    if (b) { e.preventDefault(); e.stopPropagation(); open(b.dataset.notify, b.dataset.notifyName); }
  }, true);
  document.getElementById('notifyClose').addEventListener('click', close);
  dlg.addEventListener('click', e => { if (e.target === dlg) close(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !dlg.hidden) close(); });
  // if Shopify needs a full page post (captcha), reopen this dialog with the result afterwards
  const nf = document.getElementById('notifyForm');
  nf && nf.addEventListener('killik:fallback', () => { try { sessionStorage.setItem('killikNotify', '1'); } catch (err) { /* storage unavailable */ } });
  let fromDialog = false;
  try { fromDialog = sessionStorage.getItem('killikNotify') === '1'; sessionStorage.removeItem('killikNotify'); } catch (err) { fromDialog = false; }
  if (fromDialog && dlg.querySelector('[data-notify-posted], [data-form-error]:not([hidden])')) open('', '', true);
})();
